export const money = (n) =>
  `$${Number(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const STATUS = ["Nouveau", "Collecté", "En traitement", "Traité", "Dispatché", "Livré"];

export const orderPieces = (o) => {
  if (typeof o?.total_pieces === "number") return o.total_pieces;
  return (o?.items || []).reduce((a, it) => a + (Number(it.quantity) || 0), 0);
};

export const orderWeight = (o) => {
  if (typeof o?.total_weight === "number") return o.total_weight;
  return (o?.items || []).reduce((a, it) => a + (Number(it.weight) || 0), 0);
};

export const normalizePhone = (raw) => {
  if (!raw) return null;
  const digits = String(raw).replace(/\D/g, "");
  let national = digits;
  if (digits.startsWith("243")) national = digits.slice(3);
  else if (digits.startsWith("0")) national = digits.slice(1);
  if (national.length !== 9) return null;
  return "+243" + national;
};

export const isValidPhone = (raw) => !!normalizePhone(raw);

export const statusStyle = {
  Nouveau: "bg-blue-50 text-blue-700 border-blue-200",
  Collecté: "bg-amber-50 text-amber-700 border-amber-200",
  "En traitement": "bg-indigo-50 text-indigo-700 border-indigo-200",
  Traité: "bg-purple-50 text-purple-700 border-purple-200",
  Dispatché: "bg-cyan-50 text-cyan-700 border-cyan-200",
  Livré: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Annulée: "bg-rose-50 text-rose-700 border-rose-200",
};

export const statusDot = {
  Nouveau: "bg-blue-500",
  Collecté: "bg-amber-500",
  "En traitement": "bg-indigo-500",
  Traité: "bg-purple-500",
  Dispatché: "bg-cyan-500",
  Livré: "bg-emerald-500",
  Annulée: "bg-rose-500",
};

export const roleLabel = {
  super_admin: "Super Admin",
  logistics_manager: "Chargé Logistique",
  courier: "Livreur",
  repassage: "Repassage",
  tri_etiquetage: "Tris & Étiquetage",
};

export const paymentModeLabel = {
  cash: "Espèces",
  bank: "Banque",
  mobile_money: "Mobile Money",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
